import React from 'react';
import PropTypes from 'prop-types';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import ScenarioSelectionRedefinedSectionMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ScenarioSelectionRedefinedSectionMetaOverride';
import { ProposalInflowsSectionLayout } from './ProposalInflowsSectionLayout';

export const ProposalInflowsSection = ({ resource }) => {
  return (
    <MetaResourceRenderer
      resource={resource}
      layout={ProposalInflowsSectionLayout}
      metaOverrideSet={ScenarioSelectionRedefinedSectionMetaOverride}
    />
  );
};

ProposalInflowsSection.propTypes = {
  resource: PropTypes.object.isRequired,
};
